import { ConnectionBlockActionCreator } from "../actions";
import { selectIsConvergent, selectIsFTTBUser, selectIsMobileUser } from "../selectors";
var onMountTariff = function onMountTariff() {
  return function (dispatch, getState) {
    var state = getState();
    var isMobileUser = selectIsMobileUser(state);
    var isFTTBUser = selectIsFTTBUser(state);
    var isConvergent = selectIsConvergent(state);
    dispatch(ConnectionBlockActionCreator.fetchBalances());
    dispatch(ConnectionBlockActionCreator.fetchFubGroups());
    if (isMobileUser) {
      dispatch(ConnectionBlockActionCreator.fetchMobileConnection());
      dispatch(ConnectionBlockActionCreator.fetchConnectionPrice());
    }
    if (isFTTBUser) {
      dispatch(ConnectionBlockActionCreator.fetchFTTBConnection());
    }
    if (isConvergent) {
      dispatch(ConnectionBlockActionCreator.fetchMobileConnection());
      dispatch(ConnectionBlockActionCreator.fetchConnectionPrice());
      dispatch(ConnectionBlockActionCreator.fetchConvergent());
    }
  };
};
export var ActionCreatorTariff = {
  onMountTariff: onMountTariff
};